import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppSettings } from 'src/app/shared/app-settings';
import { RestService } from 'src/app/services/rest-service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccountHistoryComponent } from '../account-history/account-history.component';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { MatDialog,MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-account-configuration',
  templateUrl: './account-configuration.component.html',
  styleUrls: ['./account-configuration.component.css']
,
  standalone: false
})
export class AccountConfigurationComponent implements OnInit {

  parentAccounts: { potentialId:string; unitId:string; status: boolean; siteName:any;ticketCreationDuration:any }[] = [];
  submitAccount: any;
  username: string;
  filteredParentAccounts: { potentialId:string; unitId:string; status: boolean;siteName:any;ticketCreationDuration:any }[] = [];
  selectedAccounts: { potentialId: string; unitId: string; status: boolean; siteName: any;ticketCreationDuration:any }[] = [];
  selectedSkipIndiaTSS: boolean | null = null;
  originalStatusOfSelectedRow: boolean | null = null;
  currentuser: any;
  showDialog = false;
  showConfirmDialog = false;
  showBothChangedDialog = false; 
  isLoading = false;
  filteredAccounts = [];
  selectedDurations = [];
  selectedValues: number[] = [];  
  siteNames: any;
  selectedStatus: any;
  selectedValue: number;
  tickets: any[];
  potentialId: any;
  status: any;
  ticketDuration: HTMLOptionElement | HTMLOptGroupElement;
  rowChanges: { [potentialId: string]: { status?: boolean, ticketCreationDuration?: number } } = {};

  constructor(
    public restService: RestService,
    public authService: AuthenticationService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AccountConfigurationComponent>,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
    ) { }

  ngOnInit(): void {
    this.getCurrentuser();
    this.getParentAccounts();
  }

  getCurrentuser() {
    this.currentuser = this.authService.currentUserValue;
    if (this.currentuser) {
      this.username = this.currentuser.email;
    }
  }


  getParentAccounts(){
    let url = `${AppSettings.PARENT_ACCOUNTS}`
    this.isLoading = true;
    this.spinner.activate();
    this.restService.getRequest(url,'').subscribe((response: any)=>{
      this.isLoading = false;
      if(response && response.data){
      this.parentAccounts = response.data.filter(a=>a.siteName !=null)  
      this.filteredParentAccounts = [...this.parentAccounts];
      this.spinner.deactivate();
      } else {
        this.spinner.deactivate();
      }
    },(error)=>{
      this.isLoading = false;
      this.spinner.deactivate();
    })
  }  

  toggleAccountSelection(account: any, event: Event, dropdownType: 'status' | 'duration'): void {
    const target = event.target as HTMLSelectElement;
    const newValue = dropdownType === 'status' ? (target.value === 'true') : parseInt(target.value);
  
    if (!this.rowChanges[account.potentialId]) {
      this.rowChanges[account.potentialId] = {};
    }
    this.rowChanges[account.potentialId][dropdownType] = newValue;
  
    const accountIndex = this.selectedAccounts.findIndex(a => 
      a.potentialId === account.potentialId && 
      a.unitId === account.unitId &&
      a.siteName === account.siteName
    );
  
    if (accountIndex !== -1) {
      this.selectedAccounts[accountIndex][dropdownType] = newValue; 
    } else {
      this.selectedAccounts.push({ ...account, [dropdownType]: newValue });
    }
    this.siteNames = this.selectedAccounts.map(a => a.siteName);
    this.tickets = this.selectedAccounts.map(a => a.ticketCreationDuration);

    if (this.selectedAccounts.length === 1) {
      this.selectedSkipIndiaTSS = this.selectedAccounts[0].status;
      this.originalStatusOfSelectedRow = this.selectedAccounts[0].status;
    } else if (this.selectedAccounts.length > 1){
      const allSameStatus = this.selectedAccounts.every(a => a.status === this.selectedAccounts[0].status);
      if (allSameStatus) {
          this.selectedSkipIndiaTSS = this.selectedAccounts[0].status;
      } else {
          this.selectedSkipIndiaTSS = null;
      }
      this.originalStatusOfSelectedRow = null;
    } else {
      this.selectedSkipIndiaTSS = null;
      this.originalStatusOfSelectedRow = null;
    }

    const index = this.filteredParentAccounts.findIndex(a => a === account);
    if (index !== -1) {
      this.filteredParentAccounts[index][dropdownType] = newValue; 
    }
  }

  canSubmit(): boolean {
    return Object.keys(this.rowChanges).length > 0 || this.selectedAccounts.length > 0; 
  }  


  allDropdownOptions: string[] = ['1','2','3','4','5'];

  filteredDropdownOptions(data: any): string[] {
    return this.allDropdownOptions.filter(option => option !== this.filteredParentAccounts[0]?.ticketCreationDuration);
  }

  submitData() {
    const url = `${AppSettings.SUBMIT_ACCOUNTS}`;
    const customConfigRequests = Object.entries(this.rowChanges).map(([potentialId, changes]) => {
      const originalAccount = this.parentAccounts.find(a => a.potentialId === potentialId);
      return {
        potentialID: potentialId,
        indiaTssSkip: changes.status ?? originalAccount?.status ?? false, 
        ticketCreationDuration: changes['duration'] ?? originalAccount?.ticketCreationDuration ?? null,
        userId: this.username
      };
    });

    const payLoad = { customConfigRequests };
    this.restService.postRequest(url,payLoad).subscribe((data)=>{
      this.submitAccount = data;
      this.toastr.success('Account Configurations Saved Successfully');
      this.spinner.deactivate();
      this.selectedAccounts.length = 0
      this.selectedSkipIndiaTSS = null
      this.dialogRef.close();
      this.navigateAccountConfiguration();
    },(error)=>{
      this.toastr.error('Please try again after sometime');
      this.spinner.deactivate();
    })
  }
  getHistory() {
    this.dialogRef.close();
    this.dialog.open(AccountHistoryComponent,{
      width: '90vw',
      height: '90vh',
      maxWidth: '90vw',
      panelClass: 'centered-modal'
    })
  }

  navigateAccountConfiguration() {
    this.spinner.activate();
    this.dialog.open(AccountConfigurationComponent, {
      width: '90vw',
      height: '90vh',
      maxWidth: '90vw',
      panelClass: 'centered-modal',
    }).afterClosed().subscribe(()=>{
      this.spinner.deactivate();
    });
  }

  handleInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.selectedAccounts = [];
    this.applyFilter(value);
  }

  applyFilter(filterValue: string) {
    if (!filterValue) {
        this.filteredParentAccounts = [...this.parentAccounts];
        return;
    }

    filterValue = filterValue?.toLowerCase();

    this.filteredParentAccounts = this.parentAccounts?.filter(account => 
        account.siteName?.toLowerCase().includes(filterValue) ||
        account.potentialId?.includes(filterValue) ||
        account.unitId?.includes(filterValue)
    );
}

openDialog(): void {
  const durationOnlyChanges = Object.values(this.rowChanges).some(changes =>
    changes['duration'] !== undefined && changes.status === undefined
  );

  const bothChanged = Object.values(this.rowChanges).some(changes =>
    changes['duration'] !== undefined && changes.status !== undefined
  );

  if (durationOnlyChanges) {
    this.showConfirmDialog = true;
    this.showDialog = false;
    this.showBothChangedDialog = false;
  } else if (bothChanged) {
    this.showBothChangedDialog = true;
    this.showDialog = false;
    this.showConfirmDialog = false;
  } else if (this.selectedAccounts.length > 0) {
    this.showDialog = true;
    this.showConfirmDialog = false;
    this.showBothChangedDialog = false;
  } else {
    this.toastr.error('Please make changes before submitting.');
  }
}

  closeDialog(): void {
    this.showDialog = false;
    this.showConfirmDialog = false;
    this.showBothChangedDialog = false;
    this.selectedAccounts = [];
    this.rowChanges = {};
    this.filteredParentAccounts = this.parentAccounts.map(account => ({ ...account }));
    this.cdr.detectChanges();
  }

  openConfirmDialog():void {
    this.showConfirmDialog = true;
  }

   closeConfirmDialog():void {
    this.showConfirmDialog = false;
   }

}
